import { Flex, Text } from "@jsq/ds/core";
import { DocumentRowItem } from "~/pages/Compliance/CaseDetailsDrawer/Documents/types";
import { TypedAGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { fullHeightCell } from "../styles_vanilla.css";

interface Props {
  params: TypedAGGridCellRenderParams<DocumentRowItem>;
}

export const ProfileRoleCellRenderer = ({ params }: Props) => {
  const profileRole = params.value;

  return (
    <Flex alignItems="center" className={fullHeightCell}>
      <Text data-testid="profile-role-label">{profileRole || "--"}</Text>
    </Flex>
  );
};
